module.exports = __webpack_public_path__ + "static/media/empty-elements.84ae53cf.svg";